<!-- 机器人消息，对应webim的 5-6 -->
<!-- 答案+关联问题 -->
<template>
  <div>
    <div class="batch-wrap">
      <div v-html="answerContent"></div>
      <div class="batch-head">
        <div class="batch-head-tip" v-html= "answerText" ></div>
        <div class="batch-head-btn" v-if="qlist.length > pagecount" @click="changePage">
          <img class="batch-head-icon icon-primay" src="../assets/changeBatch.svg" />
          <div class="batch-head-msg">换一批</div>
        </div>
      </div>
      <div class="batch-body">
        <div v-for="(item, index) in showLit" :key="index" class="batch-body-list">
          <a class="msg-link"
            :href="`qdweb://webim/message/ext2robotsendc2b?content=${textToUnicode(item.text)}&ext=${textToUnicode(JSON.stringify(item))}`"
          >{{item.text}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotMsgFilter from '@/utils/robotMsgFilter';
import Utils from '@/utils/string';
import { textToUnicode } from '@/utils/htmlDecode';

export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const { content = '', answer_type } = this.message.content;
    // eslint-disable-next-line camelcase
    const answerText = Utils.coverEmojIndex2EmojiImg(content) || (answer_type === 1 ? '你可能还想问' : '猜你想问');
    return {
      index: 0,
      pagecount: this.message.content.pagecount,
      qlist: this.message.content.list || [],
      answer: this.message.content.answer,
      answerType: answer_type,
      answerText,
    };
  },

  computed: {
    answerContent() {
      return Utils.coverEmojIndex2EmojiImg(robotMsgFilter(this.answer.content));
    },
    /**
     * 获取需要显示的列表内容
     */
    showLit() {
      const { pagecount, index, qlist } = this;
      const start = pagecount * index;
      const end = (pagecount * (index + 1)) > qlist.length ? qlist.length : (pagecount * (index + 1));
      return qlist.slice(start, end);
    },
  },

  methods: {
    /**
     * 换一批
     */
    changePage() {
      const { pagecount, index, qlist } = this;
      this.index = (index + 1) * pagecount >= qlist.length ? 0 : index + 1;
    },
    /**
     * 将字符串中的 & 符转成unicode编码
     */
    textToUnicode(text)  {
      return textToUnicode(text);
    },
  },
};
</script>

<style lang="less" scoped>
  .batch-wrap{
    .batch-text{
      margin-bottom: 10px;
      line-height: 20px;
      word-break: break-word;
      word-wrap: break-word;
      white-space: pre-wrap;
      color: #222;
    }
    .batch-head{
      // height: 20px;
      line-height: 20px;
      margin-bottom: 4px;
      margin-top: 10px;
      overflow: hidden;
      &-tip{
        width: 150px;
        font-size: 12px;
        color: #a8abb3;
        float: left;
      }
      .batch-head-btn {
        white-space: nowrap;
        text-align: center;
        cursor: pointer;
        display: flex;
        float: right;
        .batch-head-msg {
          width: 36px;
          font-size: 12px;
          color: @primary;
        }
        .batch-head-icon {
          height: 12px;
          width: 12px;
          margin: 4px 4px 0 5px;
        }
      }
    }
    .batch-body{
      &-list{
        margin: 4px 0 2px;
        font-size: 13px;
        line-height: 1.54;
        .msg-link{
          color: @primary;
        }
      }
    }
  }
/deep/
.emojiText-image {
  height: 20px;
  vertical-align: top;
  min-width: 20px;
  max-width: 20px;
}
</style>
